import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";
import {DceComponent, debounce} from "dce-engine";
import {findFragmentParent, Fragment} from "dce-fragments";
import Dce from "dce-engine/lib/decorators/Dce";
import choices from "choices.js/public/types/src/scripts/reducers/choices";
import Choices from "choices.js";
import {Choice} from "choices.js/src/scripts/interfaces/choice";
import {EventInput} from "@fullcalendar/common";

interface DynamicSelectProps {
}

interface SelectOption {
    val: string;
    label: string
}

/**
 * Komponent do aktualizacji opcji z fragmentu
 */
@Dce("DynamicSelect")
export default class DynamicSelect extends DceComponent<DynamicSelectProps> {

    private parentFragment: Fragment;
    private select: HTMLSelectElement;

    constructor(elem: DceHTMLElement, props: DynamicSelectProps) {
        super(elem, props);
        this.parentFragment = findFragmentParent(elem);

        this.select = this.elem as unknown as HTMLSelectElement;
    }

    public setOptions(options: SelectOption[]): void {

        this.select.value = '';

        while (this.select.options.length > 0){
            this.select.options.remove(0);
        }

        options.forEach(o => {
            let opt = document.createElement('option');
            opt.setAttribute('value', o.val);
            opt.innerHTML = o.label;
            this.select.add(opt);
        });

    }

}